import React from 'react';
import { Smartphone } from 'lucide-react';

/**
 * Marca o lançamento que veio do portal do motorista.
 *
 * O gestor precisa distinguir à primeira vista o que ele mesmo digitou do que
 * chegou da rua: o lançamento do motorista não passou por conferência de
 * ninguém e é o candidato natural a ser revisado. Só o caso do motorista ganha
 * selo — marcar também o da gestão encheria a tela de ruído, já que é a maioria.
 */
const OrigemBadge: React.FC<{ origem?: string | null; className?: string }> = ({ origem, className = '' }) => {
  if (origem !== 'portal_motorista') return null;

  return (
    <span
      title="Lançado pelo motorista, pelo portal"
      className={`inline-flex items-center gap-1 rounded-full bg-cyan-50 px-2 py-0.5 text-xs font-medium text-cyan-700 ring-1 ring-inset ring-cyan-600/20 ${className}`}
    >
      <Smartphone className="w-3 h-3" />
      Motorista
    </span>
  );
};

export default OrigemBadge;
